<template>
  <div>
    <div
      v-if="gettingData"
      class="d-flex flex-column align-items-center mt-8 py-6 loadingicon text-center"
    >
      <atom-spinner
        :animation-duration="1000"
        color="#2ba8b0"
        class="mx-auto"
      />
      <p class="font-weight-bold mt-4" style="color: #2ba8b0">
        در حال بارگذاری اطلاعات...
      </p>
    </div>
    <v-card class="common-card-panel" v-else>
      <v-col lg="12" md="12" sm="12" xs="12">
        <v-row>
          <v-col lg="4" md="4" sm="4" xs="4">
            <div class="title-card-employee">
              <h4 class="title_sub_card">مدیریت چک‌ها</h4>
            </div>
          </v-col>
          <v-col lg="5" md="5" sm="5" xs="5"></v-col>
        </v-row>
      </v-col>

      <v-col lg="12" md="12">
        <v-text-field
          density="compact"
          variant="outlined"
          v-model="filter"
          placeholder="جستجو در شماره چک، نام مشتری و مقدار..."
        ></v-text-field>
      </v-col>
      <!-- <v-row>
          <v-col lg="10" md="10"></v-col>
          <v-col lg="2" md="2">
            <vue-excel-xlsx
              :data="computedItems"
              class="darkGreen-mainBtn"
              :columns="excelFields"
              :filename="'انبارداری فروشگاه '"
              sheetname="انبارداری فروشگاه"
            >
              <v-icon class="white--text">mdi-file-excel</v-icon> دریافت اکسل
            </vue-excel-xlsx>
          </v-col>
        </v-row> -->
      <v-row>
        <v-col lg="12" md="12">
          <v-data-table
            :headers="headers"
            :items="computedItems"
            :search="searchField"
            :page.sync="currentPage"
            :items-per-page="perPage"
            :expanded.sync="expanded"
            no-results-text="موردی برای نمایش وجود ندارد!"
            hide-default-footer
            item-key="id"
            :loading="gettingData"
            loading-text="در حال بارگذاری اطلاعات..."
          >
            <template slot="no-data">
              <div class="font-weight-bold">موردی برای نمایش وجود ندارد!</div>
            </template>

            <!--index-->
            <template v-slot:[`item.index`]="{ index }">
              {{ index + perPage * (currentPage - 1) + 1 }}
            </template>
            <template v-slot:[`item.amount`]="{ item }">
              {{ item.amount ? Number(item.amount).toLocaleString() : "-" }}
            </template>
            <template v-slot:[`item.shopInvoiceCode`]="{ item }">
              <a
                :href="'/shop/invoice/' + item.shopInvoiceId"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ item.shopInvoiceCode }}
              </a>
            </template>
            <template v-slot:[`item.shopCustomerName`]="{ item }">
              <a
                :href="'/shop/customer/' + item.shopCustomerId"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ item.shopCustomerName }}
              </a>
            </template>
            <!-- actions -->
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                v-if="expanded.some((x) => x.id == item.id)"
                @click="toggleExpand(item)"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else @click="toggleExpand(item)"
                >mdi-chevron-down</v-icon
              >
            </template>
            <!-- expanded row -->
            <template v-slot:[`expanded-item`]="{ headers, item }">
              <td
                :colspan="headers.length"
                class="text-center d-none d-sm-table-cell"
              >
                <div class="py-2">
                  <v-btn
                    v-if="item.chequeStatus == 'ثبت شده'"
                    color="success"
                    class="text-center text-white"
                    @click="openPassCheque(item)"
                  >
                    پاس کردن
                  </v-btn>
                  <v-btn
                    v-if="item.chequeStatus == 'ثبت شده'"
                    color="error"
                    class="text-center mx-6"
                    @click="openReturnedCheque(item)"
                  >
                    برگشت زدن
                  </v-btn>
                  <v-btn
                    color="blue"
                    class="text-center text-white"
                    @click="openChequeDialog(item)"
                  >
                    جزییات
                  </v-btn>
                </div>
              </td>
              <td
                :colspan="headers.length"
                class="text-center d-flex justify-center h-100 d-sm-none"
              >
                <div class="py-2">
                  <v-btn
                    @click="openFormDetailes(item)"
                    class="my-2 me-1"
                    width="120"
                    height="42"
                    color="primary"
                    ><v-icon class="me-1">$Show</v-icon>جزئیات</v-btn
                  >
                  <v-btn
                    @click="openNoteDialog(item)"
                    class="my-2 white--text ms-3"
                    width="120"
                    height="42"
                    color="yellow darken-4"
                    ><v-icon class="me-1">$Text</v-icon>یادداشت</v-btn
                  >
                </div>
              </td>
            </template>
          </v-data-table>

          <!-- Pagination -->
          <v-pagination
            v-model="currentPage"
            :length="Math.ceil(computedItems.length / perPage)"
            :total-visible="5"
            prev-icon="mdi-arrow-left"
            next-icon="mdi-arrow-right"
            class="mt-8"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-card>

    <!--passed cheque-->
    <v-dialog v-model="passedChequeDialog" width="400">
      <v-card>
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                پاس کردن چک
              </h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2">
              <span class="pointer" @click="passedChequeDialog = false"
                ><v-icon>mdi-close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-0 pt-0" />
        <v-row class="my-4">
          <span class="ms-5">آیا اطمینان به پاس کردن چک دارید؟</span>
        </v-row>
        <div class="text-left pe-3 pb-4 pt-0 d-flex justify-end mt-4">
          <v-btn color="success" class="me-3" @click="passChequeMethod()">
            تایید
          </v-btn>
          <v-btn color="error" @click="passedChequeDialog = false">
            بستن
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!--returned cheque-->
    <v-dialog v-model="returnedChequeDialog" width="400">
      <v-card>
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                برگشت زدن چک
              </h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2">
              <span class="pointer" @click="returnedChequeDialog = false"
                ><v-icon>mdi-close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-0 pt-0" />
        <v-row class="my-4">
          <span class="ms-5">آیا اطمینان به برگشت زدن چک دارید؟</span>
        </v-row>
        <div class="text-left pe-3 pb-4 pt-0 d-flex justify-end">
          <v-btn color="success" class="me-3" @click="returedChequeMethod()">
            تایید
          </v-btn>
          <v-btn color="error" @click="returnedChequeDialog = false">
            بستن
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!--cheque details-->
    <v-dialog v-model="chequeDetailsDialog" width="400">
      <v-card>
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0 pb-0 mt-1" style="vertical-align: middle">
                جزییات چک
              </h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2 mt-3">
              <span
                class="pointer"
                @click="chequeDetailsDialog = false"
                style="color: red"
                ><v-icon>mdi-close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-0 pt-0" />
        <v-row class="my-4 mx-3">
          <v-col cols="12" md="6">
            <span>مبلغ چک: {{ selectedItem.amount }}</span>
          </v-col>
          <v-col cols="12" md="6">
            <span>تاریخ چک: {{ selectedItem.chequeDate }}</span>
          </v-col>
          <v-col cols="12" md="6">
            <span>شماره چک: {{ selectedItem.chequeNo }}</span>
          </v-col>
          <v-col cols="12" md="6">
            <span>شعبه بانک: {{ selectedItem.chequeBank }}</span>
          </v-col>
        </v-row>
        <div class="text-left pe-3 pb-4 pt-0 d-flex justify-end mt-5">
          <v-btn color="error" @click="chequeDetailsDialog = false">
            بستن
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  name: "ChequesPage",

  data() {
    return {
      chequesFields: [
        "ردیف",
        "شماره چک",
        "نام مشتری",
        "مقدار",
        "وضعیت چک",
        "عملیات",
      ],
      excelFields: [
        { field: "name", label: "نام محصول" },
        { field: "sell", label: "تعداد فروش" },
        { field: "sum", label: "تعداد موجودی" },
      ],
      currentPage: 1,
      perPage: 10,
      gettingData: false,
      searchField: "",
      expanded: [],

      headers: [
        {
          text: "#",
          sortable: false,
          value: "index",
        },
        {
          text: "شماره چک",
          value: "chequeNo",
          sortable: false,
          align: "center",
        },
        {
          text: "نام مشتری",
          value: "shopCustomerName",
          sortable: false,
          align: "center",
        },
        {
          text: "مبلغ (تومان)",
          value: "amount",
          sortable: false,
          align: "center",
        },
        {
          text: "شماره سفارش مربوطه",
          value: "shopInvoiceCode",
          sortable: false,
          align: "center",
        },
        {
          text: "وضعیت چک",
          value: "chequeStatus",
          sortable: false,
          align: "center",
        },
        { text: "عملیات", value: "actions", sortable: false, align: "center" },
      ],
      cheques: [],
      filter: "",
      gettingData: false,
      opened: [],
      returnedChequeDialog: false,
      passedChequeDialog: false,
      chequeDetailsDialog: false,
      selectedItem: {},
    };
  },

  methods: {
    toggleExpand(item) {
      if (this.expanded[0] === item) {
        this.expanded = [];
      } else {
        this.expanded = [];
        this.expanded.push(item);
      }
    },
    openChequeDialog(item) {
      this.selectedItem = JSON.parse(JSON.stringify(item));
      this.chequeDetailsDialog = true;
    },
    passChequeMethod() {
      Axios.post(
        this.baseUrl + "/satrapp/shop/payments/passCheque",
        {
          shopIncomeId: this.selectedItem.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.passedChequeDialog = false;
            this.getChequeList();
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    returedChequeMethod() {
      Axios.post(
        this.baseUrl + "/satrapp/shop/payments/returnCheque",
        {
          shopIncomeId: this.selectedItem.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.returnedChequeDialog = false;
            this.getChequeList();
          }
        })
        .catch((err) => {
          this.returnedChequeDialog = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    openPassCheque(item) {
      this.selectedItem = item;
      this.passedChequeDialog = true;
    },
    openReturnedCheque(item) {
      this.selectedItem = item;
      this.returnedChequeDialog = true;
    },
    toggle(id) {
      const index = this.opened.indexOf(id);
      if (index > -1) {
        this.opened.splice(index, 1);
      } else {
        this.opened.push(id);
      }
    },

    getChequeList() {
      Axios.get(this.baseUrl + "/satrapp/shop/payments/listCheques", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.cheques = res.data;
            console.log(this.cheques);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {
    computedItems() {
      if (this.cheques.length) {
        let filtered;
        filtered = this.cheques.filter(
          (x) =>
            (x.shopCustomerName &&
              x.shopCustomerName
                .toLowerCase()
                .includes(this.filter.toLowerCase())) ||
            (x.chequeNo &&
              x.chequeNo.toLowerCase().includes(this.filter.toLowerCase())) ||
            String(x.amount).includes(this.filter)
        );

        return filtered;
      } else return [];
    },
  },

  mounted() {
    this.getChequeList();
  },
};
</script>

<style lang="scss" scoped></style>
